module.exports = __webpack_public_path__ + "static/img/brmm2.d66d5ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/brmm2.png
// module id = 3nM4
// module chunks = 0